module.exports = __webpack_public_path__ + "media/images/avatar/9-c1cf7299d96f1842584b95537bc4444b.svg";